var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveUserIconTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03782 15.313C3.26337 13.5761 5.10886 12.0447 7.3332 12.0447H15.0248C17.2492 12.0447 19.0947 13.5761 20.3202 15.313C21.5593 17.0691 22.358 19.2944 22.358 21.1565C22.358 21.1709 22.3577 21.1853 22.3571 21.1997C22.1883 25.0999 18.9058 28.1328 15.0066 27.9955H7.35145C3.45232 28.1328 0.169679 25.0999 0.00093466 21.1997C0.000311613 21.1853 0 21.1709 0 21.1565C0 19.2944 0.798699 17.0691 2.03782 15.313ZM2.00005 21.135C2.13275 23.9319 4.49444 26.1025 7.2953 25.9963C7.30793 25.9958 7.32056 25.9955 7.3332 25.9955H15.0248C15.0375 25.9955 15.0501 25.9958 15.0627 25.9963C17.8636 26.1025 20.2252 23.9319 20.358 21.135C20.3515 19.7699 19.7336 17.9506 18.6861 16.4661C17.6195 14.9545 16.2984 14.0447 15.0248 14.0447H7.3332C6.05965 14.0447 4.73854 14.9545 3.67197 16.4661C2.62447 17.9506 2.00649 19.7699 2.00005 21.135Z",
    fill: "#1B224C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.179 2C9.48268 2 8.10742 3.37521 8.10742 5.0716C8.10742 6.768 9.48268 8.14321 11.179 8.14321C12.8754 8.14321 14.2507 6.768 14.2507 5.0716C14.2507 3.37521 12.8754 2 11.179 2ZM6.10742 5.0716C6.10742 2.27061 8.37814 0 11.179 0C13.98 0 16.2507 2.27062 16.2507 5.0716C16.2507 7.87259 13.98 10.1432 11.179 10.1432C8.37814 10.1432 6.10742 7.8726 6.10742 5.0716Z",
    fill: "#1B224C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveUserIconTab);
export default __webpack_public_path__ + "static/media/inactiveUserIconTab.38c0bbff7c99ba2b2c778753a465e3fc.svg";
export { ForwardRef as ReactComponent };